import { useState } from 'react';
import { useLang } from '../../../i18n/LanguageContext';

const testimonials = [
  {
    id: 1,
    rating: 5.0,
    contentEn: 'Studying tarot here gave me a real sense of direction in my life. The teacher is highly professional — I never imagined tarot could be both so fascinating and so well-structured.',
    contentZh: '在这里学习塔罗让我找到了人生方向。老师非常专业，在接触课程以前我从来不知道塔罗这么有意思还能这么系统！我现在已经可以独立为客户解读了，感谢感恩！',
    name: '',
    courseEn: '— From a Level 1 Professional Tarot Course',
    courseZh: '—— 来自 专业塔罗课程一阶 学员',
    avatar: 'https://public.readdy.ai/ai/img_res/aa7e96a8ecb2947321b6cc9dea766453.jpg',
  },
  {
    id: 2,
    rating: 5.0,
    contentEn: 'The energy touch healing course opened a new career path for me. From zero to mastery, the journey has been incredibly fulfilling. I can now help others with energy alignment and healing.',
    contentZh: '通灵课程彻底改变了我对自己的认知。从前我以为自己只能做一辈子的麻瓜，在老师的引导下，我开启了不一样的人生体验，也了解到观察世界的不同角度。原来它是与生俱来的，也是宇宙的神秘礼物！',
    name: '',
    courseEn: '— From a Energy Reset & Touch Healing Course student',
    courseZh: '—— 来自 灵视觉与灵性沟通课程 学员',
    avatar: 'https://readdy.ai/api/search-image?query=young%20asian%20woman%20with%20spiritual%20energy%2C%20purple%20mystical%20background%2C%20gentle%20smile%2C%20professional%20portrait%20photography%2C%20ethereal%20atmosphere&width=200&height=200&seq=testimonial-avatar-002&orientation=squarish',
  },
  {
    id: 3,
    rating: 5.0,
    contentEn: 'The Herbal Magic course helped me understand how nature\'s energy works and connect with it more deeply. As the teacher says, we don\'t use plants—we work with them. The teaching is clear and insightful, and I learned a lot.',
    contentZh: '草药魔法课程让我真正理解了自然界的能量是如何运行的，我与自然界建立了更真实的连接，正如老师所说：我们不是利用植物，而是在与它们合作。老师的教学风格非常有特色，会切实让学生知道魔药学的底层逻辑和原理，收获良多！',
    name: '',
    courseEn: '— From a Level 1 Herbal Magic student',
    courseZh: '—— 来自 草药魔法课程一阶 学员',
    avatar: 'https://readdy.ai/api/search-image?query=serene%20asian%20woman%20healer%20portrait%2C%20golden%20and%20purple%20light%2C%20peaceful%20expression%2C%20spiritual%20healing%20practitioner%2C%20professional%20photography&width=200&height=200&seq=testimonial-avatar-003&orientation=squarish',
  },
  {
    id: 4,
    rating: 5.0,
    contentEn: 'The herbal magic course is fun and practical. I especially love the elective sessions, where we learn herb properties and how to create formulas. The instructor is very knowledgeable, and every class brings something new. Highly recommended!',
    contentZh: '魔药课真的既有趣又实用！选修课是我最期待的课程，可以学到各种草药的能量属性和配方调制方法！导师知识渊博，每堂课都有新收获，强烈推荐！',
    name: '',
    courseEn: '— From a&nbsp; Level I Herbal Magic Course student',
    courseZh: '—— 来自 草药魔法课 学员',
    avatar: 'https://readdy.ai/api/search-image?query=mystical%20asian%20woman%20with%20herbs%20and%20potions%2C%20purple%20magical%20atmosphere%2C%20enchanting%20portrait%2C%20spiritual%20practitioner%2C%20soft%20lighting&width=200&height=200&seq=testimonial-avatar-004&orientation=squarish',
  },
  {
    id: 5,
    rating: 5.0,
    contentEn: 'The energy touch healing course opened up a completely new career path for me. Starting from zero to fully mastering it, the journey has been incredibly fulfilling. I can now help others with energy alignment and healing.',
    contentZh: '能量触感疗愈课程为我开辟了全新的职业道路，从零基础到完全掌握，这段旅程令我无比充实。我现在可以帮助他人进行能量调整与疗愈了！',
    name: '',
    courseEn: '— From a Energy Reset &amp; Touch Healing Course student',
    courseZh: '—— 来自 能量重置与触感疗愈课程 学员',
    avatar: 'https://readdy.ai/api/search-image?query=confident%20asian%20energy%20healer%20portrait%2C%20glowing%20purple%20aura%2C%20professional%20spiritual%20practitioner%2C%20warm%20golden%20light%2C%20elegant%20photography&width=200&height=200&seq=testimonial-avatar-005&orientation=squarish',
  },
  {
    id: 6,
    rating: 5.0,
    contentEn: 'Moon Phase Magic taught me how to align with natural energies. The new moon and full moon rituals each month are powerful and transformative. This is an incredibly practical and life-changing course!',
    contentZh: '月相魔法课程教会我如何与自然能量同频。每月的新月和满月仪式既有力量又充满转化性。这是一门极其实用、改变人生的课程！',
    name: '',
    courseEn: 'Moon Phase Magic Practical Course',
    courseZh: '—— 来自 月相魔法课程 学员',
    avatar: 'https://readdy.ai/api/search-image?query=mystical%20asian%20woman%20under%20moonlight%2C%20purple%20and%20silver%20glow%2C%20spiritual%20moon%20magic%20practitioner%2C%20dreamy%20portrait%20photography&width=200&height=200&seq=testimonial-avatar-006&orientation=squarish',
  },
];

export default function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const { t } = useLang();

  const nextTestimonial = () => setCurrentIndex((prev) => (prev + 3) % testimonials.length);
  const prevTestimonial = () => setCurrentIndex((prev) => (prev - 3 + testimonials.length) % testimonials.length);

  const visibleTestimonials = [
    testimonials[currentIndex],
    testimonials[(currentIndex + 1) % testimonials.length],
    testimonials[(currentIndex + 2) % testimonials.length],
  ];

  return (
    <section className="relative py-24 px-4 sm:px-8">
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-4 mb-4">
            <i className="ri-star-fill text-3xl text-[#d4af37]"></i>
            <h2 className="text-3xl sm:text-5xl md:text-6xl font-serif text-white">{t("Students' Magical Journeys", '学员的魔法旅程')}</h2>
            <i className="ri-star-fill text-3xl text-[#d4af37]"></i>
          </div>
          <p className="text-xl text-[#c8b6ff]">{t('Real feedback, real transformation', '真实反馈，真实蜕变')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {visibleTestimonials.map((testimonial) => (
            <div key={testimonial.id} className="bg-[#2d1b4e]/60 backdrop-blur-md rounded-3xl p-5 sm:p-8 border border-[#d4af37]/30 hover:border-[#d4af37]/50 transition-all duration-300 hover:shadow-2xl hover:shadow-[#d4af37]/20">
              <div className="mb-6">
                <div className="inline-flex items-center space-x-2 px-4 py-2 bg-[#d4af37] rounded-full">
                  <i className="ri-star-fill text-white"></i>
                  <span className="text-white font-bold">{testimonial.rating}</span>
                </div>
              </div>
              <p className="text-white text-lg leading-relaxed mb-8">
                "{t(testimonial.contentEn, testimonial.contentZh)}"
              </p>
              <div className="flex items-center space-x-4">
                <div className="flex-1">
                  {testimonial.name && (
                    <div className="text-white font-semibold text-lg">{testimonial.name}</div>
                  )}
                  <div className="text-[#d4af37] text-sm">{t(testimonial.courseEn, testimonial.courseZh)}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-center space-x-4 mt-12">
          <button onClick={prevTestimonial} className="w-12 h-12 flex items-center justify-center border-2 border-white/30 rounded-lg hover:border-[#d4af37] hover:bg-[#d4af37]/10 transition-all duration-300 cursor-pointer">
            <i className="ri-arrow-left-line text-2xl text-white"></i>
          </button>
          <button onClick={nextTestimonial} className="w-12 h-12 flex items-center justify-center bg-[#d4af37] rounded-lg hover:bg-[#f4d03f] transition-all duration-300 cursor-pointer">
            <i className="ri-arrow-right-line text-2xl text-white"></i>
          </button>
        </div>

        <div className="flex items-center justify-center space-x-2 mt-6">
          {Array.from({ length: Math.ceil(testimonials.length / 3) }).map((_, index) => (
            <button key={index} onClick={() => setCurrentIndex(index * 3)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${Math.floor(currentIndex / 3) === index ? 'bg-[#d4af37] w-8' : 'bg-white/30 hover:bg-white/50'}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
